(function (window, document) {
    // fallback banner text, this can be globaly overwritten in ghost code injection
    // <script>window.newsletterBanner = { en: {}, de: {} };</script>
    // If the banner should have custom location or text, it's also possible to place a HTML include inside a blog post with the content:
    /*
    <input type="checkbox" id="newsletter-banner" style="display: none;">
    <div class="newsletter-sticky">
        <label class="newsletter-close" for="newsletter-banner" style="float: right;">✕</label>
        <div class="newsletter-content">
            <h3>Like what you're reading?</h3>
            <p>Get notified about new articles with our free BitBox newsletter!</p>
            <a href="https://bitbox.swiss/newsletter/">Sign up now</a>
        </div>
    </div>
    */
    const newsletterBanner = window.newsletterBanner || {
        en: {
            title: 'Like what you\'re reading?',
            content: 'Get notified about new articles with our free BitBox newsletter!',
            cta: 'Sign up now',
            href: 'https://bitbox.swiss/newsletter/'
        }
    };

    const isSubscribed = (params) => {
        const text = params.toLowerCase();
        const isEmail = text.indexOf('utm_medium=email') > -1;
        const isBrevo = text.indexOf('utm_source=brevo') > -1;
        return isEmail && isBrevo;
    };

    document.addEventListener('DOMContentLoaded', () => {
        // get blog content and search for exsiting newsletter banner
        const blogPost = document.querySelector('.post-content');
        const banner = document.querySelector('.newsletter-sticky');

        if (blogPost) {
            if (banner) {
                const params = window.localStorage.getItem('params') || window.location.search;
                if (isSubscribed(params)) {
                    banner.remove();
                    document.querySelector('#newsletter-banner').remove();
                    console.info('removing newsletter banner: user already coming from newsletter');
                    return;
                }
            } else {
                const lang = document.documentElement.getAttribute('lang') || 'en';
                const paragraphs = blogPost.querySelectorAll('p');
                // at least 1 pargaph expected
                if (!paragraphs.length) {
                    console.warn('newsletter banner not inserted, no paragraphs found in', blogPost);
                    return;
                }
                const paragraph = paragraphs[Math.floor(paragraphs.length / 2)];
                const {title, content, cta, href} = newsletterBanner[lang] || newsletterBanner.en;
                if (!title || !content || !cta || !href) {
                    console.warn('newsletter banner content must have title, content, cra and href for ', lang, newsletterBanner);
                    return;
                }
                const params = window.localStorage.getItem('params') || window.location.search;
                if (isSubscribed(params)) {
                    console.info('not showing newsletter banner: user already coming from newsletter');
                    return;
                }
                const isRTL = lang in newsletterBanner && ['ar', 'fa', 'he'].includes(lang);
                paragraph.after(
                    Object.assign(document.createElement('input'), {type: 'checkbox', id: 'newsletter-banner', style: 'display: none'}),
                    Object.assign(document.createElement('div'), {
                        className: 'newsletter-sticky',
                        dir: isRTL ? 'rtl' : 'ltr',
                        innerHTML: `
    <label class="newsletter-close" for="newsletter-banner" style="float: right;">✕</label>
    <div class="newsletter-content">
        <h3>${title}</h3>
        <p>${content}</p>
        <a href="${href}" target="_blank">${cta}</a>
    </div>`
                    })
                );
            }
            blogPost.addEventListener('transitionend', (event) => {
                const newsletterCheckbox = document.querySelector('#newsletter-banner');
                if (
                    event.target.classList.contains('newsletter-sticky') &&
                    event.propertyName === 'max-height' &&
                    newsletterCheckbox?.checked
                ) {
                    event.target.remove();
                    newsletterCheckbox.remove();
                }
            });
        }
    });
})(window, document);
